import styled from 'styled-components';
import { BREAKDOWN_HEADER, FRO_BREAKDOWN_ANCHOR } from 'modules/intelligentInsights/constants';
import { heading5, spacing } from 'ui/theme';

const Header = styled.h5`
  ${heading5};
  margin-top: ${spacing.double};
  margin-bottom: ${spacing.plusHalf};
`;

export const BreakdownHeader = () => {
  return <Header id={FRO_BREAKDOWN_ANCHOR}>{BREAKDOWN_HEADER}</Header>;
};
